import React, { useCallback, useState, useEffect } from "react";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import {
  FaArrowRight,
} from "react-icons/fa";
import ModalButtons from "../../../../components/ModalButtons";
import ModalContent from "../../../../components/ModalContent";
import { 
  Button,
  Grid,
  Typography,
  Link,
} from '@material-ui/core'

import api from "../../../../services/api";

const Pais = (props) => {
  const token = localStorage.getItem("@Atlantico:token")
  
  const loadData = async ({ skip, limit, sort, filterValue }) => {
    let filter = { Filter: {} }

    if(filterValue){
      filterValue.map(item => {
        if(item.value){
          filter.Filter[item.name] = item.value
        }
      })
    }
  
    const params = {
      classe: "TnGemDCPais",
      limit,
      start:skip,
      sort,
    }
  
    const qs = '?' + new URLSearchParams(params).toString()
  
    return api.post(`v1/nweb${qs}`,filter,
      {
        headers: {
          Authorization: token,
        },
      }
    )
    .then((response) => {
      return ({data: response.data.data, count: parseInt(response.data.records)})
    })
    .catch((err) => {
      console.error(err)
    })
  
  }

  const dataSource = useCallback(loadData, [])

  const filterValue = [
    { name: 'NOMEPAIS', operator: 'startsWith', type: 'string', value: '' }
  ]

  const columns = [
    { name: 'CODIGOPAIS', header: 'Cód.', maxWidth: 80},
    {
        name: 'NOMEPAIS',
        header: 'País',
        defaultFlex: 2,
        render: ({ data }) => {
        return <Link component="button" onClick={() => { 
            props.setPais({
                [props.params[0]]: data.CODIGOPAIS,
                [props.params[1]]: data.NOMEPAIS,
            }) 

            props.setIsSubModalVisible(false)
            }}>{data.NOMEPAIS}</Link>
        }
    },
    {
        name: 'OPTN',
        header: '',
        maxWidth: 80,
        render: ({ data }) => {
            return <Button size="small" color="default" variant="contained" onClick={() => { 
                props.setPais({
                  [props.params[0]]: data.CODIGOPAIS,
                  [props.params[1]]: data.NOMEPAIS,
                }) 

                props.setIsSubModalVisible(false)
            }}><FaArrowRight /></Button>
        }
    }
  ]

  // const onRowClick = useCallback((rowProps) => {
  //   console.log(rowProps.data.NOMEFUNC)
  // }, [])

  // const onRenderRow = useCallback((rowProps) => {

  //   rowProps.onClick = (event) => {
  //     onRowClick(rowProps)
  //   }

  // })

  return (
    <>
      <ModalContent hasFooter={true}>

        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" style={{marginBottom:"20px"}}>Selecione um município</Typography>
            
            <ReactDataGrid
              idProperty="CODIGOPAIS"
              columns={columns}
              dataSource={dataSource}
              defaultLimit={200}
              defaultFilterValue={filterValue}
              pagination 
              theme="default-light" 
              defaultSortInfo={{ name: 'NOMEPAIS', dir: 1, type: 'text' }}
              style={{ minHeight: 450 }}
              // onRenderRow={onRenderRow}
             />
          </Grid>
        </Grid>
        
      </ModalContent>
      <ModalButtons></ModalButtons>
    </>
  );
};

export default Pais;
